import React, { useState, useContext, useEffect } from 'react';
import { Radio, Row, Col, Button, Tag, Alert } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { ViewDocument } from '../../../../../components';
import { Context } from '../../../../../defaults';


import './index.css';

const Question1 = ({ data, current }) => {
    const { dictionary, language, setLoading } = useContext(Context);

    return (
        <div>

            {
                data.question.answerVariants.map((el, i) => {
                    return <div
                        style={{
                            border: '1px solid #d9d9d9',
                            padding: 20,
                            marginTop: 20,
                            backgroundColor: (
                                (el.isRight === 1 && data.studentAnswer?.answerVariants.length > i && el.isRight === data.studentAnswer?.answerVariants[i].isRight) ?
                                    '#f6ffed' :
                                    ((el.isRight !== 1 && data.studentAnswer?.answerVariants.length > i && data.studentAnswer?.answerVariants[i].isRight === 1) ? '#fff1f0' : 'none'))
                        }}
                        key={`answer${el.id}`}>
                        <Row gutter={16}  >
                            <Col span={2}>
                                {
                                    el.isRight === 1 &&
                                    <Tag color='#87d068'>{dictionary?.RightAnswer[language]}</Tag>
                                }

                                {
                                    data.studentAnswer?.answerVariants.length > i &&
                                    data.studentAnswer?.answerVariants[i].isRight === 1 &&
                                    <Tag color='#2db7f5' style={{ marginTop: 10 }}>{dictionary?.StudentAnswer[language]}</Tag>
                                }
                                {/* <Tag color='green'>green</Tag>
                                <Tag color='green'>green</Tag> */}
                            </Col>
                            <Col span={22}>
                                {
                                    el.answerText &&
                                    <p>{el.answerText}</p>
                                }
                                {
                                    el.files && el.files.length > 0 &&
                                    <ViewDocument files={el.files} />
                                }
                                {
                                    el.answerHtml &&
                                    <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: el.answerHtml }} />
                                }
                            </Col>
                        </Row>
                    </div>
                })
            }
            {/* <div style={{ marginTop: 30 }}>
                <Alert message={data.studentAnswer?.isRight === 1 ? dictionary?.RightAnswer[language] : dictionary?.NotRightAnswer[language]} type={data.studentAnswer?.isRight === 1 ? 'success' : 'error'} showIcon />
            </div> */}
        </div >

    );
}

export default Question1;